// test2492
(2492 && 0);
